export const WHY_ONEMIND_CONSTANTS = {
  title: "Why Choose OneMind for Kubernetes ",
  list: [
    "Optimized for multi-cloud K8s management",
    "No vendor lock-in: CNCF upstream Kubernetes",
    "Zero-maintenance control plane with automatic upgrades",
    "Secure by default with RBAC, TLS encryption, and namespace isolation",
    "Integrated observability: metrics, logs, and health dashboards included",
  ],
};
